import { render, staticRenderFns } from "./IconDeleteUser.vue?vue&type=template&id=eba0d8ca"
import script from "./IconDeleteUser.vue?vue&type=script&lang=js"
export * from "./IconDeleteUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports